webpackJsonp([3],{

/***/ 110:
/*!***************************************!*\
  !*** ./demo-block/util/strip-tags.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

exports.strip = function (str, tags) {
  var dummyNode = document.createElement("DIV");
  dummyNode.innerHTML = str;

  tags = tags ? [].concat(tags) : [];

  tags.forEach(function (tag) {
    var targetNode = dummyNode.querySelector(tag);
    if (targetNode) {
      dummyNode.removeChild(targetNode);
    }
  });

  return dummyNode.innerHTML.trim();
};

exports.fetch = function (str, tag) {
  var dummyNode = document.createElement("DIV");
  dummyNode.innerHTML = str;

  return dummyNode.querySelector(tag) ? dummyNode.querySelector(tag).innerHTML.trim() : "";
};

/***/ }),

/***/ 111:
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./demo-block/components/demo-block.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_strip_tags__ = __webpack_require__(/*! ../util/strip-tags */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_strip_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs__ = __webpack_require__(/*! prismjs */ 201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'demo-block',
  data: function data() {
    return {
      hovering: false,
      isExpanded: false
    };
  },


  props: {
    jsfiddle: {
      default: function _default() {
        return {};
      },

      type: Object
    },
    desc: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: ''
    },
    jsResources: {
      type: String,
      default: ''
    },
    cssResources: {
      type: String,
      default: ''
    },
    bootCode: {
      type: String,
      default: ''
    }
  },

  methods: {
    goJsfiddle: function goJsfiddle() {
      var _jsfiddle = this.jsfiddle,
          script = _jsfiddle.script,
          html = _jsfiddle.html,
          style = _jsfiddle.style;

      var jsTpl = this.bootCode + '\n' + (script || '').replace(/export default/, 'var Main =').trim();
      var htmlTpl = this.jsResources + '\n<div id="app">\n' + html.trim() + '\n</div>';
      var cssTpl = this.cssResources + '\n' + (style || '').trim() + '\n';

      jsTpl = jsTpl ? jsTpl + '\nvar Ctor = Vue.extend(Main)\nnew Ctor().$mount(\'#app\')' : 'new Vue().$mount(\'#app\')';

      var data = {
        js: jsTpl,
        css: cssTpl,
        html: htmlTpl,
        panel_js: 3,
        panel_css: 1
      };
      var form = document.getElementById('fiddle-form') || document.createElement('form');
      form.innerHTML = '';
      var node = document.createElement('textarea');

      form.method = 'post';
      form.action = 'https://jsfiddle.net/api/post/library/pure/';
      form.target = '_blank';

      for (var name in data) {
        node.name = name;
        node.value = data[name].toString();
        form.appendChild(node.cloneNode());
      }
      form.setAttribute('id', 'fiddle-form');
      form.style.display = 'none';
      document.body.appendChild(form);

      form.submit();
    }
  },

  computed: {
    controlText: function controlText() {
      return this.isExpanded ? 'Hide' : 'Expand';
    },
    codeArea: function codeArea() {
      return this.$el.getElementsByClassName('meta')[0];
    },
    codeAreaHeight: function codeAreaHeight() {
      if (this.$el.getElementsByClassName('description').length > 0) {
        return this.$el.getElementsByClassName('description')[0].clientHeight + this.$el.getElementsByClassName('highlight')[0].clientHeight;
      }
      return this.$el.getElementsByClassName('highlight')[0].clientHeight;
    },
    codePrismed: function codePrismed() {
      var hl = __WEBPACK_IMPORTED_MODULE_1_prismjs___default.a.highlight(__WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default.a.strip(this.code, ['desc', 'lang', 'no-boot-code']).replace(/\/\*.*\*\/\s*/g, ''), __WEBPACK_IMPORTED_MODULE_1_prismjs___default.a.languages[this.lang] || __WEBPACK_IMPORTED_MODULE_1_prismjs___default.a.languages.markup);
      return '<pre v-pre data-lang="' + this.lang + '"><code class="lang-' + this.lang + '">' + hl + '</code></pre>';
    }
  },

  watch: {
    isExpanded: function isExpanded(val) {
      this.codeArea.style.height = val ? this.codeAreaHeight + 1 + 'px' : '0';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var highlight = _this.$el.getElementsByClassName('highlight')[0];
      if (_this.$el.getElementsByClassName('description').length === 0) {
        highlight.style.width = '100%';
        highlight.borderRight = 'none';
      }
    });
  }
});

/***/ }),

/***/ 112:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Inputs/Checkbox.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ 113:
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Inputs/Radio.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-radio',
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ 114:
/*!***************************************************!*\
  !*** ../src/components/Inputs/formGroupInput.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./formGroupInput.vue */ 115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcd8cb2_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-adcd8cb2","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./formGroupInput.vue */ 210);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-adcd8cb2","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./formGroupInput.vue */ 209)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcd8cb2_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 115:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Inputs/formGroupInput.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'fg-input',
  props: {
    required: Boolean,
    label: String,
    error: String,
    labelClasses: String,
    inputClasses: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String
  },
  data: function data() {
    return {
      touched: false,
      focused: false,
      hadError: false
    };
  },

  computed: {
    listeners: function listeners() {
      return Object.assign({}, this.$listeners, {
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      });
    },
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  },
  methods: {
    updateValue: function updateValue(evt) {
      var value = evt.target.value;
      if (!this.touched && value) {
        this.touched = true;
      }
      this.$emit('input', value);
    },
    onFocus: function onFocus(value) {
      this.focused = true;
      this.$emit('focus', value);
    },
    onBlur: function onBlur(value) {
      this.focused = false;
      this.$emit('blur', value);
    }
  },
  watch: {
    error: function error(value) {
      if (value) {
        this.hadError = true;
      }
    }
  }
});

/***/ }),

/***/ 116:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Switch.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-switch',
  props: {
    value: [Array, Boolean],
    onText: String,
    offText: String,
    color: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'].includes(value);
      }
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      var classes = base + state;
      if (this.color) {
        classes = classes + ' ' + base + this.color;
      }
      return classes;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ 117:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Progress.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-progress',
  props: {
    striped: Boolean,
    showText: Boolean,
    animated: Boolean,
    height: {
      type: Number,
      default: 4
    },
    type: {
      type: String,
      default: 'default'
    },
    value: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    computedClasses: function computedClasses() {
      return ['bg-' + this.type, { 'progress-bar-striped': this.striped }, { 'progress-bar-animated': this.animated }];
    }
  },
  methods: {
    progressClasses: function progressClasses(progress) {
      return ['bg-' + progress.type, { 'progress-bar-striped': progress.striped }, { 'progress-bar-animated': progress.animated }];
    }
  }
});

/***/ }),

/***/ 118:
/*!**************************************!*\
  !*** ../src/components/Dropdown.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Dropdown.vue */ 119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7b9a9d_hasScoped_true_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0d7b9a9d","hasScoped":true,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Dropdown.vue */ 218);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0d7b9a9d","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Dropdown.vue */ 217)
}
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d7b9a9d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7b9a9d_hasScoped_true_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 119:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Dropdown.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    position: String,
    hideArrow: Boolean,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    }
  }
});

/***/ }),

/***/ 120:
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Table.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-table',
  props: {
    columns: Array,
    data: Array
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
});

/***/ }),

/***/ 121:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Transitions/FadeRenderTransition.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fade-render-transition',
  props: {
    duration: {
      type: Number,
      default: 300
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  methods: {
    beforeAppear: function beforeAppear(el) {
      el.style.opacity = 0;
    },
    onAppear: function onAppear(el) {
      el.style.transform = 'translate3d(0, -60px, 0)';
      el.style.transition = 'all ' + this.duration / 1000 + 's ease-in';
      if (this.delay > 0) {
        el.style.transition = el.style.transition + ' ' + this.delay / 1000 + 's';
      }
    },
    afterAppear: function afterAppear(el) {
      el.style.opacity = 1;
      el.style.transform = 'translate3d(0, 0, 0)';
    }
  }
});

/***/ }),

/***/ 122:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Cards/Card.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card',
  props: {
    title: String,
    subTitle: String
  }
});

/***/ }),

/***/ 123:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Cards/ChartCard.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card_vue__ = __webpack_require__(/*! ./Card.vue */ 39);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1__Card_vue__["a" /* default */]
  },
  props: {
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    },
    responsiveOptions: [Object, Array]
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null,
      chart: null
    };
  },

  methods: {
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions, this.responsiveOptions);
      this.$emit('initialized', this.chart);
      if (this.chartType === 'Line') {
        this.animateLineChart();
      }
      if (this.chartType === 'Bar') {
        this.animateBarChart();
      }
    },

    /***
     * Assigns a random id to the chart
     */
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    animateLineChart: function animateLineChart() {
      var _this = this;

      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: _this.$Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === 'point') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
      seq = 0;
    },
    animateBarChart: function animateBarChart() {
      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'bar') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! chartist */ 124));

            case 3:
              Chartist = _context.sent;

              this.$Chartist = Chartist.default ? Chartist.default : Chartist;
              this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),

/***/ 125:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Cards/StatsCard.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card_vue__ = __webpack_require__(/*! ./Card.vue */ 39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__Card_vue__["a" /* default */]
  },
  props: {
    title: String,
    subTitle: String
  }
});

/***/ }),

/***/ 126:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Breadcrumb/Breadcrumb.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumb'
});

/***/ }),

/***/ 127:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Breadcrumb/BreadcrumbItem.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumb-item',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 128:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Pagination.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-pagination',
  props: {
    color: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple'].includes(value);
      }
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.color;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ 129:
/*!************************************************!*\
  !*** ../src/components/SidebarPlugin/index.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__(/*! ./SideBar.vue */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__(/*! ./SidebarItem.vue */ 246);



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');
    // we simulate the window Resize so the charts will get updated in realtime.
    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ 130:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/SidebarPlugin/SideBar.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'Vue LBD PRO'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: 'static/img/sidebar-5.jpg'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/vue-logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide: function provide() {
    return {
      autoClose: this.autoClose
    };
  },

  computed: {
    sidebarStyle: function sidebarStyle() {
      return {
        backgroundImage: 'url(' + this.backgroundImage + ')'
      };
    }
  },
  methods: {
    initScrollBarAsync: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, /*! perfect-scrollbar/dist/css/perfect-scrollbar.css */ 505));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, /*! perfect-scrollbar */ 506));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initScrollBarAsync() {
        return _ref.apply(this, arguments);
      }

      return initScrollBarAsync;
    }()
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ 131:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/SidebarPlugin/SidebarItem.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_transitions_collapse_transition__ = __webpack_require__(/*! element-ui/lib/transitions/collapse-transition */ 132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_transitions_collapse_transition__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-item',
  components: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true
    }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route && this.$route.path) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    linkClick: function linkClick() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ }),

/***/ 134:
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Alert.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_transitions__ = __webpack_require__(/*! vue2-transitions */ 252);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-alert',
  components: {
    FadeTransition: __WEBPACK_IMPORTED_MODULE_0_vue2_transitions__["a" /* FadeTransition */]
  },
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type'
    },
    dismissible: {
      type: Boolean,
      default: false,
      description: 'Whether alert is dismissible (closeable)'
    },
    icon: {
      type: String,
      default: '',
      description: 'Alert icon to display'
    }
  },
  data: function data() {
    return {
      visible: true
    };
  },

  methods: {
    dismissAlert: function dismissAlert() {
      this.visible = false;
    }
  }
});

/***/ }),

/***/ 135:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/Button.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-button',
  props: {
    tag: {
      type: String,
      default: 'button',
      description: 'Button html tag'
    },
    round: Boolean,
    icon: Boolean,
    block: Boolean,
    loading: Boolean,
    outline: Boolean,
    wide: Boolean,
    disabled: Boolean,
    type: {
      type: String,
      default: 'default',
      description: 'Button type (primary|secondary|danger etc)'
    },
    nativeType: {
      type: String,
      default: 'button',
      description: 'Button native type (e.g button, input etc)'
    },
    size: {
      type: String,
      default: '',
      description: 'Button size (sm|lg)'
    },
    simple: {
      type: Boolean,
      description: 'Whether button is simple (outlined)'
    },
    link: {
      type: Boolean,
      description: 'Whether button is a link (no borders or background)'
    }
  },
  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});

/***/ }),

/***/ 175:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/NotificationPlugin/Notifications.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification_vue__ = __webpack_require__(/*! ./Notification.vue */ 421);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_0__Notification_vue__["a" /* default */]
  },
  props: {
    transitionName: {
      type: String,
      default: 'list'
    },
    transitionMode: {
      type: String,
      default: 'in-out'
    },
    overlap: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      notifications: this.$notifications.state
    };
  },

  methods: {
    removeNotification: function removeNotification(timestamp) {
      this.$notifications.removeNotification(timestamp);
    }
  },
  created: function created() {
    this.$notifications.settings.overlap = this.overlap;
  },

  watch: {
    overlap: function overlap(newVal) {
      this.$notifications.settings.overlap = newVal;
    }
  }
});

/***/ }),

/***/ 176:
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!../src/components/NotificationPlugin/Notification.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification',
  components: {
    contentRender: {
      props: ['component'],
      render: function render(h) {
        // register component locally if it's not registered
        var componentsObj = this.$options.components;
        if (!componentsObj[this.component.name]) {
          componentsObj[this.component.name] = this.component;
        }
        return h(this.component);
      }
    }
  },
  props: {
    message: String,
    title: String,
    icon: String,
    verticalAlign: {
      type: String,
      default: 'top',
      validator: function validator(value) {
        var acceptedValues = ['top', 'bottom'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    horizontalAlign: {
      type: String,
      default: 'right',
      validator: function validator(value) {
        var acceptedValues = ['left', 'center', 'right'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    type: {
      type: String,
      default: 'info',
      validator: function validator(value) {
        var acceptedValues = ['info', 'primary', 'danger', 'warning', 'success'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    timeout: {
      type: Number,
      default: 5000,
      validator: function validator(value) {
        return value >= 0;
      }
    },
    timestamp: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    component: {
      type: [Object, Function]
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    clickHandler: Function
  },
  data: function data() {
    return {
      elmHeight: 0
    };
  },

  computed: {
    hasIcon: function hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType: function alertType() {
      return 'alert-' + this.type;
    },
    customPosition: function customPosition() {
      var _this = this;

      var initialMargin = 20;
      var alertHeight = this.elmHeight + 10;
      var sameAlertsCount = this.$notifications.state.filter(function (alert) {
        return alert.horizontalAlign === _this.horizontalAlign && alert.verticalAlign === _this.verticalAlign && alert.timestamp <= _this.timestamp;
      }).length;
      if (this.$notifications.settings.overlap) {
        sameAlertsCount = 1;
      }
      var pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      var styles = {};
      if (this.verticalAlign === 'top') {
        styles.top = pixels + 'px';
      } else {
        styles.bottom = pixels + 'px';
      }
      return styles;
    }
  },
  methods: {
    close: function close() {
      this.$emit('close', this.timestamp);
    },
    tryClose: function tryClose(evt) {
      if (this.clickHandler) {
        this.clickHandler(evt, this);
      }
      if (this.closeOnClick) {
        this.close();
      }
    }
  },
  mounted: function mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
});

/***/ }),

/***/ 177:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/props-table.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "props-table",
  props: {
    componentName: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      parsedData: {}
    };
  },

  computed: {
    hasProps: function hasProps() {
      return this.parsedData.props && Object.keys(this.parsedData.props).length > 0;
    }
  },
  methods: {
    getType: function getType(prop) {
      var propType = prop.type ? prop.type : prop;
      if ((typeof propType === "undefined" ? "undefined" : _typeof(propType)) === "object" && propType.length) {
        return propType.map(function (t) {
          return t.name;
        }).join(" | ");
      }
      return propType.name || "N/A";
    },
    getDefault: function getDefault(prop) {
      if (!prop.default) {
        return 'N/A';
      }
      if (typeof prop.default === 'function') {
        return prop.default();
      }
      return prop.default;
    }
  },
  mounted: function mounted() {
    try {
      var compFunction = this.$root.$options.components[this.componentName];
      if (compFunction) {
        var rawComponent = new compFunction();
        if (rawComponent) {
          this.parsedData = rawComponent.$options || {};
        }
      }
    } catch (e) {
      console.warn(e);
    }
  }
});

/***/ }),

/***/ 194:
/*!************************!*\
  !*** multi ./index.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/index.js */195);


/***/ }),

/***/ 195:
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__theme_vue_scss__ = __webpack_require__(/*! ./theme/vue.scss */ 196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__theme_vue_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__theme_vue_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo_block_plugin__ = __webpack_require__(/*! ./demo-block/plugin */ 197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_index_js__ = __webpack_require__(/*! ../src/components/index.js */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_Alert__ = __webpack_require__(/*! ../src/components/Alert */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_light_bootstrap_main__ = __webpack_require__(/*! ../src/light-bootstrap-main */ 254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_props_table__ = __webpack_require__(/*! ./components/props-table */ 431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_chartist__ = __webpack_require__(/*! ../node_modules/chartist */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__ = __webpack_require__(/*! ../node_modules/element-ui */ 136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_element_ui_packages_theme_chalk_src_index_scss__ = __webpack_require__(/*! ../node_modules/element-ui/packages/theme-chalk/src/index.scss */ 434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_element_ui_packages_theme_chalk_src_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__node_modules_element_ui_packages_theme_chalk_src_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__ = __webpack_require__(/*! vue2-google-maps */ 435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_vue_form_wizard__ = __webpack_require__(/*! ../node_modules/vue-form-wizard */ 500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__node_modules_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node_modules_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(/*! ../node_modules/vue-form-wizard/dist/vue-form-wizard.min.css */ 501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node_modules_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__node_modules_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_sweetalert2__ = __webpack_require__(/*! ../node_modules/sweetalert2 */ 502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__node_modules_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__node_modules_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(/*! ../node_modules/sweetalert2/dist/sweetalert2.css */ 503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__node_modules_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__node_modules_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_static_css_nucleo_icons_css__ = __webpack_require__(/*! ../public/static/css/nucleo_icons.css */ 504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_static_css_nucleo_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__public_static_css_nucleo_icons_css__);




var Vue = window.Vue;












window.swal = __WEBPACK_IMPORTED_MODULE_12__node_modules_sweetalert2___default.a;
Vue.use(__WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__, {
  load: {
    key: 'AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw'
  }
});

Vue.use(__WEBPACK_IMPORTED_MODULE_4__src_light_bootstrap_main__["a" /* default */]);

Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["Select"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["Option"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["Tag"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["Slider"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["DatePicker"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["Progress"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_7__node_modules_element_ui__["TimePicker"]);
Vue.use(__WEBPACK_IMPORTED_MODULE_10__node_modules_vue_form_wizard___default.a);
Vue.component(__WEBPACK_IMPORTED_MODULE_5__components_props_table__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__components_props_table__["a" /* default */]);
Vue.component(__WEBPACK_IMPORTED_MODULE_3__src_components_Alert__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__src_components_Alert__["a" /* default */]);
window.Chartist = __WEBPACK_IMPORTED_MODULE_6__node_modules_chartist___default.a;

for (var key in __WEBPACK_IMPORTED_MODULE_2__src_components_index_js__) {
  var toRegister = __WEBPACK_IMPORTED_MODULE_2__src_components_index_js__[key];
  if (toRegister.install) {
    Vue.use(toRegister);
  } else {
    if (toRegister.name) {
      Vue.component(toRegister.name, toRegister);
    }
  }
}
window.DemoBoxVue = {
  create: __WEBPACK_IMPORTED_MODULE_1__demo_block_plugin__["a" /* create */]
};

/***/ }),

/***/ 196:
/*!************************!*\
  !*** ./theme/vue.scss ***!
  \************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/*!************************************!*\
  !*** ./demo-block/plugin/index.js ***!
  \************************************/
/*! exports provided: create */
/*! exports used: create */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return create; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(/*! ../components/ */ 198);
var Vue = window.Vue;


var create = function create(jsResources, cssResources, bootCode) {
  return function (hook, vm) {
    var id = 0;
    window.$docsify.markdown = {
      renderer: {
        code: function code(_code, lang) {
          if (/^\/\*\s*vue\s*\*\//.test(_code)) {
            id++;
            var DemoBlockWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__components___["a" /* generateComponent */])(_code, lang, jsResources, cssResources, bootCode);
            Vue.component('DemoBox' + id, DemoBlockWrapper);
            return '<' + 'demo-box-' + id + '></demo-box-' + id + '>';
          } else {
            lang = lang || '';
            var hl = Prism.highlight(_code, Prism.languages[lang] || Prism.languages.markup);
            return '<pre v-pre data-lang="' + lang + '"><code class="lang-' + lang + '">' + hl + '</code></pre>';
          }
        }
      }
    };
  };
};

/***/ }),

/***/ 198:
/*!****************************************!*\
  !*** ./demo-block/components/index.js ***!
  \****************************************/
/*! exports provided: install, generateComponent */
/*! exports used: generateComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_strip_tags__ = __webpack_require__(/*! ../util/strip-tags */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_strip_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo_block__ = __webpack_require__(/*! ./demo-block */ 199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(/*! marked */ 203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
var Vue = window.Vue;




var install = function install() {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__demo_block__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__demo_block__["a" /* default */]);
};

var generateComponent = function generateComponent(code, lang, jsResources, cssResources, bootCode) {
  var html = __WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default.a.fetch(code, 'template');
  var style = __WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default.a.fetch(code, 'style');
  var script = __WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default.a.fetch(code, 'script');
  var descOrg = __WEBPACK_IMPORTED_MODULE_0__util_strip_tags___default.a.fetch(code, 'desc');
  var desc = __WEBPACK_IMPORTED_MODULE_2_marked___default.a && __WEBPACK_IMPORTED_MODULE_2_marked___default()(descOrg) || descOrg;
  var noBootCode = code.indexOf('/*no-boot-code*/') > -1;
  if (noBootCode) {
    bootCode = "";
  }

  var allJsResources = jsResources;

  var extraJsMatchStrList = code.match(/\/\*\s*jsResource\s*(.*\S)\s*\*\//);
  if (!!extraJsMatchStrList) {
    var jsList = extraJsMatchStrList[1].split(' ');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = jsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var js = _step.value;

        allJsResources += '\n<script src="' + js + '"></script>';
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  var scripts = script.split('export default');
  var scriptStrOrg = '(function() {' + scripts[0] + ' ; return ' + scripts[1] + '})()';
  var scriptStr = Babel && Babel.transform(scriptStrOrg, { presets: ['es2015'] }).code || scriptStrOrg;
  var scriptObj = eval(scriptStr);

  scriptObj.template = html;

  var jsfiddleStr = JSON.stringify({ html: html, style: style, script: script });

  return {
    template: '\n      <demo-block class="demo-box"\n        :jsfiddle="jsfiddle"\n        :code="code"\n        :desc="desc"\n        :lang="lang"\n        :js-resources="allJsResources"\n        :css-resources="cssResources"\n        :boot-code="bootCode"\n        :no-boot-code="noBootCode">\n        <div class="source" slot="source">\n          <my-code></my-code>\n        </div>\n      </demo-block/>\n    ',

    components: {
      DemoBlock: __WEBPACK_IMPORTED_MODULE_1__demo_block__["a" /* default */],
      MyCode: scriptObj
    },

    data: function data() {
      return {
        jsfiddle: { html: html, style: style, script: script },
        code: code,
        desc: desc,
        lang: lang,
        allJsResources: allJsResources,
        cssResources: cssResources,
        bootCode: bootCode,
        noBootCode: noBootCode
      };
    }
  };
};

/***/ }),

/***/ 199:
/*!**********************************************!*\
  !*** ./demo-block/components/demo-block.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_demo_block_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./demo-block.vue */ 111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1e49b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_block_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3a1e49b8","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./demo-block.vue */ 202);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3a1e49b8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./demo-block.vue */ 200)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_demo_block_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1e49b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_block_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 200:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a1e49b8","scoped":false,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo-block/components/demo-block.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 202:
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1e49b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo-block/components/demo-block.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-block",class:{ 'hover': _vm.hovering },on:{"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}},[_vm._t("source"),_vm._v(" "),_c('div',{staticClass:"meta"},[(_vm.desc)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.desc)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"highlight",domProps:{"innerHTML":_vm._s(_vm.codePrismed)}})]),_vm._v(" "),_c('div',{ref:"control",staticClass:"demo-block-control",on:{"click":function($event){_vm.isExpanded = !_vm.isExpanded}}},[_c('transition',{attrs:{"name":"arrow-slide"}}),_vm._v(" "),_c('transition',{attrs:{"name":"text-slide"}},[_c('span',[_vm._v(_vm._s(_vm.controlText))])])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 204:
/*!**********************************!*\
  !*** ../src/components/index.js ***!
  \**********************************/
/*! exports provided: Checkbox, Switch, Progress, Pagination, Radio, FormGroupInput, Card, ChartCard, StatsCard, Table, DropDown, SidebarPlugin, FadeRenderTransition, Breadcrumb, BreadcrumbItem, default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Inputs_Checkbox_vue__ = __webpack_require__(/*! ./Inputs/Checkbox.vue */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Inputs_Radio_vue__ = __webpack_require__(/*! ./Inputs/Radio.vue */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inputs_formGroupInput_vue__ = __webpack_require__(/*! ./Inputs/formGroupInput.vue */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Switch_vue__ = __webpack_require__(/*! ./Switch.vue */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Progress_vue__ = __webpack_require__(/*! ./Progress.vue */ 214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dropdown_vue__ = __webpack_require__(/*! ./Dropdown.vue */ 118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_vue__ = __webpack_require__(/*! ./Table.vue */ 219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transitions_FadeRenderTransition_vue__ = __webpack_require__(/*! ./Transitions/FadeRenderTransition.vue */ 222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cards_Card_vue__ = __webpack_require__(/*! ./Cards/Card.vue */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Cards_ChartCard_vue__ = __webpack_require__(/*! ./Cards/ChartCard.vue */ 227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Cards_StatsCard_vue__ = __webpack_require__(/*! ./Cards/StatsCard.vue */ 232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Breadcrumb_Breadcrumb_vue__ = __webpack_require__(/*! ./Breadcrumb/Breadcrumb.vue */ 235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Breadcrumb_BreadcrumbItem_vue__ = __webpack_require__(/*! ./Breadcrumb/BreadcrumbItem.vue */ 238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pagination_vue__ = __webpack_require__(/*! ./Pagination.vue */ 241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SidebarPlugin__ = __webpack_require__(/*! ./SidebarPlugin */ 129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_0__Inputs_Checkbox_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_3__Switch_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return __WEBPACK_IMPORTED_MODULE_4__Progress_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return __WEBPACK_IMPORTED_MODULE_13__Pagination_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_1__Inputs_Radio_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupInput", function() { return __WEBPACK_IMPORTED_MODULE_2__Inputs_formGroupInput_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_8__Cards_Card_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChartCard", function() { return __WEBPACK_IMPORTED_MODULE_9__Cards_ChartCard_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StatsCard", function() { return __WEBPACK_IMPORTED_MODULE_10__Cards_StatsCard_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_6__Table_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropDown", function() { return __WEBPACK_IMPORTED_MODULE_5__Dropdown_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SidebarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_14__SidebarPlugin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FadeRenderTransition", function() { return __WEBPACK_IMPORTED_MODULE_7__Transitions_FadeRenderTransition_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_11__Breadcrumb_Breadcrumb_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return __WEBPACK_IMPORTED_MODULE_12__Breadcrumb_BreadcrumbItem_vue__["a"]; });






















var components = {
  Checkbox: __WEBPACK_IMPORTED_MODULE_0__Inputs_Checkbox_vue__["a" /* default */],
  Switch: __WEBPACK_IMPORTED_MODULE_3__Switch_vue__["a" /* default */],
  Progress: __WEBPACK_IMPORTED_MODULE_4__Progress_vue__["a" /* default */],
  Pagination: __WEBPACK_IMPORTED_MODULE_13__Pagination_vue__["a" /* default */],
  Radio: __WEBPACK_IMPORTED_MODULE_1__Inputs_Radio_vue__["a" /* default */],
  FormGroupInput: __WEBPACK_IMPORTED_MODULE_2__Inputs_formGroupInput_vue__["a" /* default */],
  Card: __WEBPACK_IMPORTED_MODULE_8__Cards_Card_vue__["a" /* default */],
  ChartCard: __WEBPACK_IMPORTED_MODULE_9__Cards_ChartCard_vue__["a" /* default */],
  StatsCard: __WEBPACK_IMPORTED_MODULE_10__Cards_StatsCard_vue__["a" /* default */],
  Table: __WEBPACK_IMPORTED_MODULE_6__Table_vue__["a" /* default */],
  DropDown: __WEBPACK_IMPORTED_MODULE_5__Dropdown_vue__["a" /* default */],
  SidebarPlugin: __WEBPACK_IMPORTED_MODULE_14__SidebarPlugin__["a" /* default */],
  FadeRenderTransition: __WEBPACK_IMPORTED_MODULE_7__Transitions_FadeRenderTransition_vue__["a" /* default */],
  Breadcrumb: __WEBPACK_IMPORTED_MODULE_11__Breadcrumb_Breadcrumb_vue__["a" /* default */],
  BreadcrumbItem: __WEBPACK_IMPORTED_MODULE_12__Breadcrumb_BreadcrumbItem_vue__["a" /* default */]
};


/* harmony default export */ __webpack_exports__["default"] = (components);

/***/ }),

/***/ 205:
/*!*********************************************!*\
  !*** ../src/components/Inputs/Checkbox.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Checkbox.vue */ 112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4049767a_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4049767a","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Checkbox.vue */ 206);
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4049767a_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 206:
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4049767a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Inputs/Checkbox.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check",class:[_vm.inlineClass, {disabled: _vm.disabled}]},[_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.cbId}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-check-input",attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"form-check-sign"}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 207:
/*!******************************************!*\
  !*** ../src/components/Inputs/Radio.vue ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Radio.vue */ 113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26ee1d13_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-26ee1d13","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Radio.vue */ 208);
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26ee1d13_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 208:
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ee1d13","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Inputs/Radio.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check form-check-radio",class:_vm.inlineClass},[_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.cbId}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-check-input",attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('span',{staticClass:"form-check-sign"}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 209:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-adcd8cb2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Inputs/formGroupInput.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adcd8cb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Inputs/formGroupInput.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
     {'input-group': _vm.hasIcon},
     {'has-right-slot': _vm.addonRightIcon || this.$slots.addonRight},
     {'has-error': _vm.error},
     {'input-group-focus': _vm.focused},
     {'has-label': _vm.label || _vm.$slots.label},
     {'has-success': !_vm.error && _vm.touched && _vm.hadError}]},[_vm._t("label",function(){return [(_vm.label)?_c('label',{class:_vm.labelClasses},[_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e()]}),_vm._v(" "),(_vm.addonLeftIcon || _vm.$slots.addonLeft)?_c('span',{staticClass:"input-group-addon input-group-prepend"},[_vm._t("addonLeft",function(){return [_c('i',{class:_vm.addonLeftIcon})]})],2):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_c('input',_vm._g(_vm._b({staticClass:"form-control",class:[{valid: _vm.value && !_vm.error}, _vm.inputClasses],attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.listeners))]}),_vm._v(" "),(_vm.addonRightIcon || _vm.$slots.addonRight)?_c('span',{staticClass:"input-group-addon input-group-append"},[_vm._t("addonRight",function(){return [_c('i',{class:_vm.addonRightIcon})]})],2):_vm._e(),_vm._v(" "),_vm._t("infoBlock"),_vm._v(" "),_vm._t("helpBlock",function(){return [(_vm.error)?_c('div',{staticClass:"text-danger invalid-feedback",class:{'mt-2': _vm.hasIcon},staticStyle:{"display":"block"}},[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 211:
/*!************************************!*\
  !*** ../src/components/Switch.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Switch.vue */ 116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_37bc123e_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-37bc123e","hasScoped":false,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Switch.vue */ 213);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-37bc123e","scoped":false,"hasInlineConfig":true}!../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Switch.vue */ 212)
}
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_37bc123e_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 212:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37bc123e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Switch.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37bc123e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Switch.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){return _vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.color)},[_vm._t("on",function(){return [_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")]})],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",function(){return [_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 214:
/*!**************************************!*\
  !*** ../src/components/Progress.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Progress.vue */ 117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_302469e9_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-302469e9","hasScoped":false,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Progress.vue */ 216);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-302469e9","scoped":false,"hasInlineConfig":true}!../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Progress.vue */ 215)
}
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_302469e9_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 215:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-302469e9","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Progress.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302469e9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Progress.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",style:(("height: " + _vm.height + "px"))},[(_vm.values.length === 0)?_c('div',{staticClass:"progress-bar",class:_vm.computedClasses,style:(("width: " + _vm.value + "%;")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm._t("default",function(){return [(_vm.showText)?_c('span',[_vm._v("\n           "+_vm._s(_vm.value)+"%\n        ")]):_vm._e()]})],2):_vm._l((_vm.values),function(progress){return _c('div',{key:progress.value,staticClass:"progress-bar",class:_vm.progressClasses(progress),style:(("width: " + (progress.value) + "%;"))},[(progress.text)?_c('span',[_vm._v("\n         "+_vm._s(progress.text)+"\n      ")]):_vm._e()])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 217:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d7b9a9d","scoped":true,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Dropdown.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d7b9a9d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Dropdown.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"component",staticClass:"dropdown nav-item",class:[{show: _vm.isOpen}],attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"dropdown-toggle nav-link",class:{'hide-arrow': _vm.hideArrow},attrs:{"data-toggle":"dropdown"}},[_vm._t("title",function(){return [_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})]})],2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",class:[{'dropdown-menu-right': _vm.position === 'right'}, {show: _vm.isOpen}]},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 219:
/*!***********************************!*\
  !*** ../src/components/Table.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Table.vue */ 120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad0fc8cc_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ad0fc8cc","hasScoped":false,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Table.vue */ 221);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ad0fc8cc","scoped":false,"hasInlineConfig":true}!../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Table.vue */ 220)
}
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad0fc8cc_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 220:
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad0fc8cc","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Table.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad0fc8cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Table.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()})},{"row":item})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 222:
/*!**************************************************************!*\
  !*** ../src/components/Transitions/FadeRenderTransition.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_FadeRenderTransition_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./FadeRenderTransition.vue */ 121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac154aee_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_FadeRenderTransition_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ac154aee","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./FadeRenderTransition.vue */ 224);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ac154aee","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./FadeRenderTransition.vue */ 223)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_FadeRenderTransition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac154aee_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_FadeRenderTransition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 223:
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac154aee","scoped":false,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Transitions/FadeRenderTransition.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac154aee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Transitions/FadeRenderTransition.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""},on:{"before-appear":_vm.beforeAppear,"appear":_vm.onAppear,"after-appear":_vm.afterAppear}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 225:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bee77698","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Cards/Card.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 226:
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bee77698","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Cards/Card.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header || _vm.title)?_c('div',{staticClass:"card-header"},[_vm._t("header",function(){return [_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v(_vm._s(_vm.subTitle))])]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 227:
/*!*********************************************!*\
  !*** ../src/components/Cards/ChartCard.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./ChartCard.vue */ 123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dbab2a1_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0dbab2a1","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./ChartCard.vue */ 231);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0dbab2a1","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./ChartCard.vue */ 228)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dbab2a1_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 228:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dbab2a1","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Cards/ChartCard.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dbab2a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Cards/ChartCard.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card chart-card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 232:
/*!*********************************************!*\
  !*** ../src/components/Cards/StatsCard.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./StatsCard.vue */ 125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_021ebe39_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-021ebe39","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./StatsCard.vue */ 234);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-021ebe39","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./StatsCard.vue */ 233)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_021ebe39_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 233:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-021ebe39","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Cards/StatsCard.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021ebe39","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Cards/StatsCard.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-stats"},[_c('div',{staticClass:"row"},[(_vm.$slots.header)?_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_vm._t("header")],2)]):_vm._e(),_vm._v(" "),(_vm.$slots.content || _vm.title)?_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_vm._t("content",function(){return [(_vm.subTitle)?_c('p',{staticClass:"card-category"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),_vm._v(" "),(_vm.title)?_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]})],2)]):_vm._e()]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 235:
/*!***************************************************!*\
  !*** ../src/components/Breadcrumb/Breadcrumb.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Breadcrumb.vue */ 126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd2f2ee_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-bdd2f2ee","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Breadcrumb.vue */ 237);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-bdd2f2ee","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Breadcrumb.vue */ 236)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd2f2ee_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 236:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdd2f2ee","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Breadcrumb/Breadcrumb.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdd2f2ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Breadcrumb/Breadcrumb.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb","role":"navigation"}},[_c('ol',{staticClass:"breadcrumb"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 238:
/*!*******************************************************!*\
  !*** ../src/components/Breadcrumb/BreadcrumbItem.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbItem_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./BreadcrumbItem.vue */ 127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ea6c95_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbItem_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-00ea6c95","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./BreadcrumbItem.vue */ 240);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-00ea6c95","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./BreadcrumbItem.vue */ 239)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ea6c95_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 239:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00ea6c95","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Breadcrumb/BreadcrumbItem.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ea6c95","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Breadcrumb/BreadcrumbItem.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-item",class:{active: _vm.active}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 241:
/*!****************************************!*\
  !*** ../src/components/Pagination.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Pagination.vue */ 128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e004dc2_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0e004dc2","hasScoped":false,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Pagination.vue */ 242);
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e004dc2_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 242:
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e004dc2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Pagination.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('span',[_vm._v("«")])])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-item page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('span',[_vm._v("»")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 243:
/*!***************************************************!*\
  !*** ../src/components/SidebarPlugin/SideBar.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./SideBar.vue */ 130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcf51a88_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fcf51a88","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./SideBar.vue */ 245);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-fcf51a88","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./SideBar.vue */ 244)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcf51a88_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 244:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fcf51a88","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/SidebarPlugin/SideBar.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcf51a88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/SidebarPlugin/SideBar.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage,"data-active-color":_vm.activeColor}},[_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"logo-mini",attrs:{"href":"https://www.creative-tim.com/product/vue-light-bootstrap-dashboard-pro"}},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}})])]),_vm._v(" "),_c('a',{staticClass:"simple-text logo-normal",attrs:{"href":""}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("links",function(){return _vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}),1)})})],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 246:
/*!*******************************************************!*\
  !*** ../src/components/SidebarPlugin/SidebarItem.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./SidebarItem.vue */ 131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5476e1_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2c5476e1","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./SidebarItem.vue */ 250);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2c5476e1","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./SidebarItem.vue */ 247)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5476e1_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 247:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c5476e1","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/SidebarPlugin/SidebarItem.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 250:
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c5476e1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/SidebarPlugin/SidebarItem.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",staticClass:"nav-item",class:{active : _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{staticClass:"nav-link sidebar-menu-item",attrs:{"aria-expanded":!_vm.collapsed,"data-toggle":"collapse"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",function(){return [_c(_vm.elementType(_vm.link, false),{tag:"component",staticClass:"nav-link",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path},nativeOn:{"click":function($event){return _vm.linkClick.apply(null, arguments)}}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 251:
/*!***********************************!*\
  !*** ../src/components/Alert.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Alert.vue */ 134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b82584_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-75b82584","hasScoped":false,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Alert.vue */ 253);
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b82584_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 253:
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b82584","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Alert.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',[(_vm.visible)?_c('div',{staticClass:"alert",class:[("alert-" + _vm.type), { 'alert-with-icon': _vm.icon }],attrs:{"role":"alert"}},[(!_vm.dismissible)?_vm._t("default"):[_vm._t("dismiss-icon",function(){return [_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.dismissAlert}},[_c('i',{staticClass:"nc-icon nc-simple-remove"})])]}),_vm._v(" "),(_vm.icon || _vm.$slots.icon)?[_vm._t("icon",function(){return [_c('span',{class:_vm.icon,attrs:{"data-notify":"icon"}})]})]:_vm._e(),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._t("default")],2)]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 254:
/*!**************************************!*\
  !*** ../src/light-bootstrap-main.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills__ = __webpack_require__(/*! ./polyfills */ 255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(/*! vee-validate */ 258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalComponents__ = __webpack_require__(/*! ./globalComponents */ 259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globalDirectives__ = __webpack_require__(/*! ./globalDirectives */ 343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SidebarPlugin__ = __webpack_require__(/*! ./components/SidebarPlugin */ 129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NotificationPlugin__ = __webpack_require__(/*! ./components/NotificationPlugin */ 418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs__ = __webpack_require__(/*! vue-nav-tabs */ 425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en__ = __webpack_require__(/*! element-ui/lib/locale/lang/en */ 426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale__ = __webpack_require__(/*! element-ui/lib/locale */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(/*! bootstrap/dist/css/bootstrap.css */ 427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs_themes_vue_tabs_scss__ = __webpack_require__(/*! vue-nav-tabs/themes/vue-tabs.scss */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs_themes_vue_tabs_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs_themes_vue_tabs_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__(/*! ./assets/sass/light-bootstrap-dashboard.scss */ 429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_demo_css__ = __webpack_require__(/*! ./assets/css/demo.css */ 430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_css_demo_css__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


// Notifications plugin. Used on Notifications page
// Validation plugin used to validate forms

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// Tabs plugin. Used on Panels page.


// element ui language configuration


__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en___default.a);

// asset imports





/* harmony default export */ __webpack_exports__["a"] = ({
  install: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(Vue) {
      return __WEBPACK_IMPORTED_MODULE_0__Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalComponents__["a" /* default */]);
              Vue.use(__WEBPACK_IMPORTED_MODULE_4__globalDirectives__["a" /* default */]);
              Vue.use(__WEBPACK_IMPORTED_MODULE_5__components_SidebarPlugin__["a" /* default */]);
              Vue.use(__WEBPACK_IMPORTED_MODULE_6__components_NotificationPlugin__["a" /* default */]);
              Vue.use(__WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs___default.a);
              Vue.use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* default */]);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function install(_x) {
      return _ref.apply(this, arguments);
    }

    return install;
  }()
});

/***/ }),

/***/ 255:
/*!***************************!*\
  !*** ../src/polyfills.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(/*! es6-promise/auto */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* eslint-disable */

/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ 259:
/*!**********************************!*\
  !*** ../src/globalComponents.js ***!
  \**********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Inputs_formGroupInput_vue__ = __webpack_require__(/*! ./components/Inputs/formGroupInput.vue */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dropdown_vue__ = __webpack_require__(/*! ./components/Dropdown.vue */ 118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cards_Card_vue__ = __webpack_require__(/*! ./components/Cards/Card.vue */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button_vue__ = __webpack_require__(/*! ./components/Button.vue */ 260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(/*! element-ui */ 136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);





/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_Dropdown_vue__["a" /* default */]);
    Vue.component('card', __WEBPACK_IMPORTED_MODULE_2__components_Cards_Card_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_Button_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_Button_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Input"].name, __WEBPACK_IMPORTED_MODULE_4_element_ui__["Input"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4_element_ui__["InputNumber"].name, __WEBPACK_IMPORTED_MODULE_4_element_ui__["InputNumber"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ 260:
/*!************************************!*\
  !*** ../src/components/Button.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Button.vue */ 135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f06392_hasScoped_true_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(/*! !../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-58f06392","hasScoped":true,"buble":{"transforms":{}}}!../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Button.vue */ 262);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-58f06392","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Button.vue */ 261)
}
var normalizeComponent = __webpack_require__(/*! ../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f06392"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f06392_hasScoped_true_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 261:
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58f06392","scoped":true,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/Button.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f06392","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/Button.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"btn",class:[
    { 'btn-round': _vm.round },
    { 'btn-block': _vm.block },
    { 'btn-outline': _vm.outline },
    { 'btn-wd': _vm.wide },
    { 'btn-icon btn-fab': _vm.icon },
    ( _obj = {}, _obj[("btn-" + _vm.type)] = _vm.type, _obj ),
    ( _obj$1 = {}, _obj$1[("btn-" + _vm.size)] = _vm.size, _obj$1 ),
    { 'btn-simple': _vm.simple },
    { 'btn-link': _vm.link },
    { disabled: _vm.disabled && _vm.tag !== 'button' }
  ],attrs:{"type":_vm.tag === 'button' ? _vm.nativeType : '',"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[_vm._t("loading",function(){return [(_vm.loading)?_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_vm._e()]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 343:
/*!**********************************!*\
  !*** ../src/globalDirectives.js ***!
  \**********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(/*! vue-clickaway */ 344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__(/*! v-tooltip */ 345);



/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1_v_tooltip__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ 39:
/*!****************************************!*\
  !*** ../src/components/Cards/Card.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Card.vue */ 122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee77698_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-bee77698","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Card.vue */ 226);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-bee77698","scoped":false,"hasInlineConfig":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Card.vue */ 225)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee77698_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 418:
/*!*****************************************************!*\
  !*** ../src/components/NotificationPlugin/index.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notifications_vue__ = __webpack_require__(/*! ./Notifications.vue */ 419);


var NotificationStore = {
  state: [], // here the notifications will be added
  settings: {
    overlap: false,
    verticalAlign: 'top',
    horizontalAlign: 'right',
    type: 'info',
    timeout: 5000,
    closeOnClick: true,
    showClose: true
  },
  setOptions: function setOptions(options) {
    this.settings = Object.assign(this.settings, options);
  },
  removeNotification: function removeNotification(timestamp) {
    var indexToDelete = this.state.findIndex(function (n) {
      return n.timestamp === timestamp;
    });
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addNotification: function addNotification(notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      notification = { message: notification };
    }
    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(notification.timestamp.getMilliseconds() + this.state.length);
    notification = Object.assign({}, this.settings, notification);
    this.state.push(notification);
  },
  notify: function notify(notification) {
    var _this = this;

    if (Array.isArray(notification)) {
      notification.forEach(function (notificationInstance) {
        _this.addNotification(notificationInstance);
      });
    } else {
      this.addNotification(notification);
    }
  }
};

var NotificationsPlugin = {
  install: function install(Vue, options) {
    var app = new Vue({
      data: {
        notificationStore: NotificationStore
      },
      methods: {
        notify: function notify(notification) {
          this.notificationStore.notify(notification);
        }
      }
    });
    Vue.prototype.$notify = app.notify;
    Vue.prototype.$notifications = app.notificationStore;
    Vue.component('Notifications', __WEBPACK_IMPORTED_MODULE_0__Notifications_vue__["a" /* default */]);
    if (options) {
      NotificationStore.setOptions(options);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (NotificationsPlugin);

/***/ }),

/***/ 419:
/*!**************************************************************!*\
  !*** ../src/components/NotificationPlugin/Notifications.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Notifications.vue */ 175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b63049e_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5b63049e","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Notifications.vue */ 424);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5b63049e","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Notifications.vue */ 420)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b63049e_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 420:
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b63049e","scoped":false,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/NotificationPlugin/Notifications.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/*!*************************************************************!*\
  !*** ../src/components/NotificationPlugin/Notification.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../../docs/node_modules/vue-loader/lib/selector?type=script&index=0!./Notification.vue */ 176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fb198ee_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(/*! !../../../docs/node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9fb198ee","hasScoped":false,"buble":{"transforms":{}}}!../../../docs/node_modules/vue-loader/lib/selector?type=template&index=0!./Notification.vue */ 423);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../docs/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../docs/node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-9fb198ee","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../docs/node_modules/vue-loader/lib/selector?type=styles&index=0!./Notification.vue */ 422)
}
var normalizeComponent = __webpack_require__(/*! ../../../docs/node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_docs_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__docs_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fb198ee_hasScoped_false_buble_transforms_docs_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 422:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9fb198ee","scoped":false,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/components/NotificationPlugin/Notification.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fb198ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/NotificationPlugin/Notification.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert open",class:[
    { 'alert-with-icon': _vm.icon },
    _vm.verticalAlign,
    _vm.horizontalAlign,
    _vm.alertType
  ],style:(_vm.customPosition),attrs:{"data-notify":"container","role":"alert","data-notify-position":"top-center"},on:{"click":_vm.tryClose}},[(_vm.showClose)?_c('button',{staticClass:"close col-xs-1",attrs:{"type":"button","aria-hidden":"true","data-notify":"dismiss"},on:{"click":_vm.close}},[_c('i',{staticClass:"nc-icon nc-simple-remove"})]):_vm._e(),_vm._v(" "),(_vm.icon)?_c('span',{class:['alert-icon', _vm.icon],attrs:{"data-notify":"icon"}}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[(_vm.title)?_c('span',{staticClass:"title"},[_c('b',[_vm._v(_vm._s(_vm.title)),_c('br')])]):_vm._e(),_vm._v(" "),(_vm.message)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e(),_vm._v(" "),(!_vm.message && _vm.component)?_c('content-render',{attrs:{"component":_vm.component}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 424:
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b63049e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/NotificationPlugin/Notifications.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":_vm.transitionName,"mode":_vm.transitionMode}},_vm._l((_vm.notifications),function(notification){return _c('notification',_vm._b({key:notification.timestamp.getTime(),attrs:{"clickHandler":notification.onClick},on:{"close":_vm.removeNotification}},'notification',notification,false))}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 429:
/*!*********************************************************!*\
  !*** ../src/assets/sass/light-bootstrap-dashboard.scss ***!
  \*********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/*!**********************************!*\
  !*** ../src/assets/css/demo.css ***!
  \**********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/*!************************************!*\
  !*** ./components/props-table.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_props_table_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/dragos/Vue-developer/vue-light-bootstrap-dashboard-pro/docs/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./props-table.vue */ 177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db9d564_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_props_table_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1db9d564","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./props-table.vue */ 433);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1db9d564","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./props-table.vue */ 432)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_dragos_Vue_developer_vue_light_bootstrap_dashboard_pro_docs_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_props_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db9d564_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_props_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 432:
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1db9d564","scoped":false,"hasInlineConfig":true}!../node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/props-table.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db9d564","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/props-table.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"props-table__wrapper bd-example"},[(_vm.hasProps)?_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.parsedData.props),function(value,key){return _c('tr',{key:key},[(key)?_c('td',[_vm._v("\n        "+_vm._s(key)+"\n      ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(_vm.getType(value))+"\n      ")]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(_vm.getDefault(value))+"\n      ")]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(value.description)+"\n      ")])])}),0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"prop-col"},[_vm._v("Prop Name")]),_vm._v(" "),_c('th',{staticClass:"type-col"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"default-col"},[_vm._v("Default")]),_vm._v(" "),_c('th',{staticClass:"description-col"},[_vm._v("Description")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 504:
/*!*********************************************!*\
  !*** ../public/static/css/nucleo_icons.css ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[194]);


// WEBPACK FOOTER //
// client.0d2ff3a6.js